import AboutHero from "../components/about/hero";
import RelatedEvents from "../components/events/related-events";
import Footer from "../components/utils/footer";
import Navbar from "../components/utils/navbar";
import backgound from "../hero/events-banner.png";

import { useState, useEffect } from "react";
import { getData } from "../services";
import { useParams } from "react-router-dom";

const SingleEvent = () => {
  const [event, setevent] = useState(null);
  const [events, setEvents] = useState([]);
  const [upcomingevents, setupcomingevents] = useState([]);
  const [loading, setloading] = useState(true);
  const id = useParams();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  useEffect(() => {
    getData(
      `https://kacit.twafwane.com/wp-json/tribe/events/v1/events/?start_date=2023-02-01`
    ).then((data) => {
      setEvents(data.events);
      const myevent = data.events.find((i) => i.slug == id.id);
      const upcomingevents = data.events.filter(
        (event) => new Date(event.start_date) > new Date()
      );
      setupcomingevents(upcomingevents);
      setevent(myevent);
      setloading(false);
    });
  }, []);
  return (
    <>
      <Navbar />
      <AboutHero
        title={loading ? "" : event.title}
        subtitle={"Events"}
        background={backgound}
      />
      <main>
        <section className="news">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="news-container container black-history">
              <div className="right">
                <div className="at-glance">
                  <h2 className="glance-title">At a glance</h2>
                  <div className="glance-content">
                    <ul>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1875"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1875)">
                              <path
                                d="M4.16667 18.3334C3.70833 18.3334 3.31583 18.1704 2.98917 17.8442C2.66306 17.5176 2.5 17.1251 2.5 16.6667V5.00008C2.5 4.54175 2.66306 4.14953 2.98917 3.82341C3.31583 3.49675 3.70833 3.33341 4.16667 3.33341H5V1.66675H6.66667V3.33341H13.3333V1.66675H15V3.33341H15.8333C16.2917 3.33341 16.6842 3.49675 17.0108 3.82341C17.3369 4.14953 17.5 4.54175 17.5 5.00008V16.6667C17.5 17.1251 17.3369 17.5176 17.0108 17.8442C16.6842 18.1704 16.2917 18.3334 15.8333 18.3334H4.16667ZM4.16667 16.6667H15.8333V8.33341H4.16667V16.6667ZM4.16667 6.66675H15.8333V5.00008H4.16667V6.66675ZM10 11.6667C9.76389 11.6667 9.56611 11.5867 9.40667 11.4267C9.24667 11.2673 9.16667 11.0695 9.16667 10.8334C9.16667 10.5973 9.24667 10.3992 9.40667 10.2392C9.56611 10.0798 9.76389 10.0001 10 10.0001C10.2361 10.0001 10.4342 10.0798 10.5942 10.2392C10.7536 10.3992 10.8333 10.5973 10.8333 10.8334C10.8333 11.0695 10.7536 11.2673 10.5942 11.4267C10.4342 11.5867 10.2361 11.6667 10 11.6667ZM6.66667 11.6667C6.43056 11.6667 6.2325 11.5867 6.0725 11.4267C5.91306 11.2673 5.83333 11.0695 5.83333 10.8334C5.83333 10.5973 5.91306 10.3992 6.0725 10.2392C6.2325 10.0798 6.43056 10.0001 6.66667 10.0001C6.90278 10.0001 7.10083 10.0798 7.26083 10.2392C7.42028 10.3992 7.5 10.5973 7.5 10.8334C7.5 11.0695 7.42028 11.2673 7.26083 11.4267C7.10083 11.5867 6.90278 11.6667 6.66667 11.6667ZM13.3333 11.6667C13.0972 11.6667 12.8994 11.5867 12.74 11.4267C12.58 11.2673 12.5 11.0695 12.5 10.8334C12.5 10.5973 12.58 10.3992 12.74 10.2392C12.8994 10.0798 13.0972 10.0001 13.3333 10.0001C13.5694 10.0001 13.7672 10.0798 13.9267 10.2392C14.0867 10.3992 14.1667 10.5973 14.1667 10.8334C14.1667 11.0695 14.0867 11.2673 13.9267 11.4267C13.7672 11.5867 13.5694 11.6667 13.3333 11.6667ZM10 15.0001C9.76389 15.0001 9.56611 14.9201 9.40667 14.7601C9.24667 14.6006 9.16667 14.4029 9.16667 14.1667C9.16667 13.9306 9.24667 13.7329 9.40667 13.5734C9.56611 13.4134 9.76389 13.3334 10 13.3334C10.2361 13.3334 10.4342 13.4134 10.5942 13.5734C10.7536 13.7329 10.8333 13.9306 10.8333 14.1667C10.8333 14.4029 10.7536 14.6006 10.5942 14.7601C10.4342 14.9201 10.2361 15.0001 10 15.0001ZM6.66667 15.0001C6.43056 15.0001 6.2325 14.9201 6.0725 14.7601C5.91306 14.6006 5.83333 14.4029 5.83333 14.1667C5.83333 13.9306 5.91306 13.7329 6.0725 13.5734C6.2325 13.4134 6.43056 13.3334 6.66667 13.3334C6.90278 13.3334 7.10083 13.4134 7.26083 13.5734C7.42028 13.7329 7.5 13.9306 7.5 14.1667C7.5 14.4029 7.42028 14.6006 7.26083 14.7601C7.10083 14.9201 6.90278 15.0001 6.66667 15.0001ZM13.3333 15.0001C13.0972 15.0001 12.8994 14.9201 12.74 14.7601C12.58 14.6006 12.5 14.4029 12.5 14.1667C12.5 13.9306 12.58 13.7329 12.74 13.5734C12.8994 13.4134 13.0972 13.3334 13.3333 13.3334C13.5694 13.3334 13.7672 13.4134 13.9267 13.5734C14.0867 13.7329 14.1667 13.9306 14.1667 14.1667C14.1667 14.4029 14.0867 14.6006 13.9267 14.7601C13.7672 14.9201 13.5694 15.0001 13.3333 15.0001Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Date
                        </span>
                        <span>{new Date(event.date).toDateString()}</span>
                      </li>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1881"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1881)">
                              <path
                                d="M12.7493 13.9167L13.916 12.7501L10.8327 9.66675V5.83341H9.16602V10.3334L12.7493 13.9167ZM9.99935 18.3334C8.84657 18.3334 7.76324 18.1145 6.74935 17.6767C5.73546 17.2395 4.85352 16.6459 4.10352 15.8959C3.35352 15.1459 2.7599 14.264 2.32268 13.2501C1.8849 12.2362 1.66602 11.1529 1.66602 10.0001C1.66602 8.8473 1.8849 7.76397 2.32268 6.75008C2.7599 5.73619 3.35352 4.85425 4.10352 4.10425C4.85352 3.35425 5.73546 2.76036 6.74935 2.32258C7.76324 1.88536 8.84657 1.66675 9.99935 1.66675C11.1521 1.66675 12.2355 1.88536 13.2493 2.32258C14.2632 2.76036 15.1452 3.35425 15.8952 4.10425C16.6452 4.85425 17.2388 5.73619 17.676 6.75008C18.1138 7.76397 18.3327 8.8473 18.3327 10.0001C18.3327 11.1529 18.1138 12.2362 17.676 13.2501C17.2388 14.264 16.6452 15.1459 15.8952 15.8959C15.1452 16.6459 14.2632 17.2395 13.2493 17.6767C12.2355 18.1145 11.1521 18.3334 9.99935 18.3334ZM9.99935 16.6667C11.8466 16.6667 13.4196 16.0176 14.7185 14.7192C16.0168 13.4204 16.666 11.8473 16.666 10.0001C16.666 8.15286 16.0168 6.5798 14.7185 5.28091C13.4196 3.98258 11.8466 3.33341 9.99935 3.33341C8.15213 3.33341 6.57935 3.98258 5.28102 5.28091C3.98213 6.5798 3.33268 8.15286 3.33268 10.0001C3.33268 11.8473 3.98213 13.4204 5.28102 14.7192C6.57935 16.0176 8.15213 16.6667 9.99935 16.6667Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Time
                        </span>
                        <span>{event.start_date_details.hour}:{event.start_date_details.minutes} - {event.end_date_details.hour}:{event.end_date_details.minutes}</span>
                      </li>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1887"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1887)">
                              <path
                                d="M10.0007 10.0001C10.459 10.0001 10.8515 9.83675 11.1782 9.51008C11.5043 9.18397 11.6673 8.79175 11.6673 8.33341C11.6673 7.87508 11.5043 7.48258 11.1782 7.15591C10.8515 6.8298 10.459 6.66675 10.0007 6.66675C9.54232 6.66675 9.1501 6.8298 8.82398 7.15591C8.49732 7.48258 8.33398 7.87508 8.33398 8.33341C8.33398 8.79175 8.49732 9.18397 8.82398 9.51008C9.1501 9.83675 9.54232 10.0001 10.0007 10.0001ZM10.0007 16.1251C11.6951 14.5695 12.952 13.1562 13.7715 11.8851C14.5909 10.6145 15.0007 9.48619 15.0007 8.50008C15.0007 6.98619 14.5179 5.74647 13.5523 4.78091C12.5873 3.81591 11.4034 3.33341 10.0007 3.33341C8.59787 3.33341 7.41371 3.81591 6.44815 4.78091C5.48315 5.74647 5.00065 6.98619 5.00065 8.50008C5.00065 9.48619 5.41037 10.6145 6.22982 11.8851C7.04926 13.1562 8.30621 14.5695 10.0007 16.1251ZM10.0007 18.3334C7.76454 16.4306 6.09454 14.6631 4.99065 13.0309C3.88621 11.3992 3.33398 9.88897 3.33398 8.50008C3.33398 6.41675 4.00426 4.75703 5.34482 3.52091C6.68482 2.2848 8.23676 1.66675 10.0007 1.66675C11.7645 1.66675 13.3165 2.2848 14.6565 3.52091C15.997 4.75703 16.6673 6.41675 16.6673 8.50008C16.6673 9.88897 16.1154 11.3992 15.0115 13.0309C13.907 14.6631 12.2368 16.4306 10.0007 18.3334Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Location
                        </span>
                        <span>
                          {event.venue.city}, {event.venue.country}
                        </span>
                      </li>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1893"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1893)">
                              <path
                                d="M2.5 17.5V5.83333H5.83333V2.5H14.1667V9.16667H17.5V17.5H10.8333V14.1667H9.16667V17.5H2.5ZM4.16667 15.8333H5.83333V14.1667H4.16667V15.8333ZM4.16667 12.5H5.83333V10.8333H4.16667V12.5ZM4.16667 9.16667H5.83333V7.5H4.16667V9.16667ZM7.5 12.5H9.16667V10.8333H7.5V12.5ZM7.5 9.16667H9.16667V7.5H7.5V9.16667ZM7.5 5.83333H9.16667V4.16667H7.5V5.83333ZM10.8333 12.5H12.5V10.8333H10.8333V12.5ZM10.8333 9.16667H12.5V7.5H10.8333V9.16667ZM10.8333 5.83333H12.5V4.16667H10.8333V5.83333ZM14.1667 15.8333H15.8333V14.1667H14.1667V15.8333ZM14.1667 12.5H15.8333V10.8333H14.1667V12.5Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Venue
                        </span>
                        <span>{event.venue.venue}</span>
                      </li>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1899"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1899)">
                              <path
                                d="M5.41667 9.16675L10 1.66675L14.5833 9.16675H5.41667ZM14.5833 18.3334C13.5417 18.3334 12.6561 17.969 11.9267 17.2401C11.1978 16.5106 10.8333 15.6251 10.8333 14.5834C10.8333 13.5417 11.1978 12.6562 11.9267 11.9267C12.6561 11.1979 13.5417 10.8334 14.5833 10.8334C15.625 10.8334 16.5106 11.1979 17.24 11.9267C17.9689 12.6562 18.3333 13.5417 18.3333 14.5834C18.3333 15.6251 17.9689 16.5106 17.24 17.2401C16.5106 17.969 15.625 18.3334 14.5833 18.3334ZM2.5 17.9167V11.2501H9.16667V17.9167H2.5ZM14.5833 16.6667C15.1667 16.6667 15.6597 16.4654 16.0625 16.0626C16.4653 15.6598 16.6667 15.1667 16.6667 14.5834C16.6667 14.0001 16.4653 13.507 16.0625 13.1042C15.6597 12.7015 15.1667 12.5001 14.5833 12.5001C14 12.5001 13.5069 12.7015 13.1042 13.1042C12.7014 13.507 12.5 14.0001 12.5 14.5834C12.5 15.1667 12.7014 15.6598 13.1042 16.0626C13.5069 16.4654 14 16.6667 14.5833 16.6667ZM4.16667 16.2501H7.5V12.9167H4.16667V16.2501ZM8.375 7.50008H11.625L10 4.87508L8.375 7.50008Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Category
                        </span>
                        <div className="flex">
                          {event.categories.map((i) => (
                            <span>{i.name}</span>
                          ))}
                        </div>
                      </li>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1905"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1905)">
                              <path
                                d="M0.833984 16.6666V14.3333C0.833984 13.861 0.955651 13.4269 1.19898 13.0308C1.44176 12.6352 1.76454 12.3333 2.16732 12.1249C3.02843 11.6944 3.90343 11.3713 4.79232 11.1558C5.68121 10.9408 6.58398 10.8333 7.50065 10.8333C8.41732 10.8333 9.3201 10.9408 10.209 11.1558C11.0979 11.3713 11.9729 11.6944 12.834 12.1249C13.2368 12.3333 13.5595 12.6352 13.8023 13.0308C14.0457 13.4269 14.1673 13.861 14.1673 14.3333V16.6666H0.833984ZM15.834 16.6666V14.1666C15.834 13.5555 15.664 12.9685 15.324 12.4058C14.9834 11.8435 14.5007 11.361 13.8757 10.9583C14.584 11.0416 15.2507 11.1838 15.8757 11.3849C16.5007 11.5866 17.084 11.8333 17.6257 12.1249C18.1257 12.4027 18.5076 12.7116 18.7715 13.0516C19.0354 13.3921 19.1673 13.7638 19.1673 14.1666V16.6666H15.834ZM7.50065 9.99992C6.58398 9.99992 5.79926 9.67353 5.14648 9.02075C4.49371 8.36797 4.16732 7.58325 4.16732 6.66659C4.16732 5.74992 4.49371 4.9652 5.14648 4.31242C5.79926 3.65964 6.58398 3.33325 7.50065 3.33325C8.41732 3.33325 9.20204 3.65964 9.85482 4.31242C10.5076 4.9652 10.834 5.74992 10.834 6.66659C10.834 7.58325 10.5076 8.36797 9.85482 9.02075C9.20204 9.67353 8.41732 9.99992 7.50065 9.99992ZM15.834 6.66659C15.834 7.58325 15.5076 8.36797 14.8548 9.02075C14.202 9.67353 13.4173 9.99992 12.5007 9.99992C12.3479 9.99992 12.1534 9.9827 11.9173 9.94825C11.6812 9.91325 11.4868 9.87492 11.334 9.83325C11.709 9.38881 11.997 8.89575 12.1982 8.35408C12.3998 7.81242 12.5007 7.24992 12.5007 6.66659C12.5007 6.08325 12.3998 5.52075 12.1982 4.97909C11.997 4.43742 11.709 3.94436 11.334 3.49992C11.5284 3.43047 11.7229 3.3852 11.9173 3.36409C12.1118 3.34353 12.3062 3.33325 12.5007 3.33325C13.4173 3.33325 14.202 3.65964 14.8548 4.31242C15.5076 4.9652 15.834 5.74992 15.834 6.66659ZM2.50065 14.9999H12.5007V14.3333C12.5007 14.1805 12.4626 14.0416 12.3865 13.9166C12.3098 13.7916 12.209 13.6944 12.084 13.6249C11.334 13.2499 10.577 12.9685 9.81315 12.7808C9.04926 12.5935 8.27843 12.4999 7.50065 12.4999C6.72287 12.4999 5.95204 12.5935 5.18815 12.7808C4.42426 12.9685 3.66732 13.2499 2.91732 13.6249C2.79232 13.6944 2.69176 13.7916 2.61565 13.9166C2.53898 14.0416 2.50065 14.1805 2.50065 14.3333V14.9999ZM7.50065 8.33325C7.95898 8.33325 8.35148 8.16992 8.67815 7.84325C9.00426 7.51714 9.16732 7.12492 9.16732 6.66659C9.16732 6.20825 9.00426 5.81603 8.67815 5.48992C8.35148 5.16325 7.95898 4.99992 7.50065 4.99992C7.04232 4.99992 6.6501 5.16325 6.32398 5.48992C5.99732 5.81603 5.83398 6.20825 5.83398 6.66659C5.83398 7.12492 5.99732 7.51714 6.32398 7.84325C6.6501 8.16992 7.04232 8.33325 7.50065 8.33325Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Organizer
                        </span>
                        <span>{event.organizer[0].organizer}</span>
                      </li>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1911"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1911)">
                              <path
                                d="M9.99935 18.3334C8.86046 18.3334 7.78407 18.1145 6.77018 17.6767C5.75629 17.2395 4.87102 16.6423 4.11435 15.8851C3.35713 15.1284 2.7599 14.2431 2.32268 13.2292C1.8849 12.2154 1.66602 11.139 1.66602 10.0001C1.66602 8.8473 1.8849 7.76758 2.32268 6.76091C2.7599 5.75369 3.35713 4.87175 4.11435 4.11508C4.87102 3.35786 5.75629 2.76036 6.77018 2.32258C7.78407 1.88536 8.86046 1.66675 9.99935 1.66675C11.1521 1.66675 12.2318 1.88536 13.2385 2.32258C14.2457 2.76036 15.1277 3.35786 15.8843 4.11508C16.6416 4.87175 17.2388 5.75369 17.676 6.76091C18.1138 7.76758 18.3327 8.8473 18.3327 10.0001C18.3327 11.139 18.1138 12.2154 17.676 13.2292C17.2388 14.2431 16.6416 15.1284 15.8843 15.8851C15.1277 16.6423 14.2457 17.2395 13.2385 17.6767C12.2318 18.1145 11.1521 18.3334 9.99935 18.3334ZM9.99935 16.6251C10.3605 16.1251 10.673 15.6042 10.9368 15.0626C11.2007 14.5209 11.416 13.9445 11.5827 13.3334H8.41602C8.58268 13.9445 8.79796 14.5209 9.06185 15.0626C9.32574 15.6042 9.63824 16.1251 9.99935 16.6251ZM7.83268 16.2917C7.58268 15.8334 7.36407 15.3576 7.17685 14.8642C6.98907 14.3715 6.83268 13.8612 6.70768 13.3334H4.24935C4.65213 14.0279 5.15546 14.632 5.75935 15.1459C6.36379 15.6598 7.0549 16.0417 7.83268 16.2917ZM12.166 16.2917C12.9438 16.0417 13.6346 15.6598 14.2385 15.1459C14.843 14.632 15.3466 14.0279 15.7493 13.3334H13.291C13.166 13.8612 13.0099 14.3715 12.8227 14.8642C12.6349 15.3576 12.416 15.8334 12.166 16.2917ZM3.54102 11.6667H6.37435C6.33268 11.389 6.30129 11.1145 6.28018 10.8434C6.25963 10.5729 6.24935 10.2917 6.24935 10.0001C6.24935 9.70841 6.25963 9.4273 6.28018 9.15675C6.30129 8.88564 6.33268 8.61119 6.37435 8.33341H3.54102C3.47157 8.61119 3.41935 8.88564 3.38435 9.15675C3.3499 9.4273 3.33268 9.70841 3.33268 10.0001C3.33268 10.2917 3.3499 10.5729 3.38435 10.8434C3.41935 11.1145 3.47157 11.389 3.54102 11.6667ZM8.04102 11.6667H11.9577C11.9993 11.389 12.0307 11.1145 12.0518 10.8434C12.0724 10.5729 12.0827 10.2917 12.0827 10.0001C12.0827 9.70841 12.0724 9.4273 12.0518 9.15675C12.0307 8.88564 11.9993 8.61119 11.9577 8.33341H8.04102C7.99935 8.61119 7.96824 8.88564 7.94768 9.15675C7.92657 9.4273 7.91602 9.70841 7.91602 10.0001C7.91602 10.2917 7.92657 10.5729 7.94768 10.8434C7.96824 11.1145 7.99935 11.389 8.04102 11.6667ZM13.6243 11.6667H16.4577C16.5271 11.389 16.5793 11.1145 16.6143 10.8434C16.6488 10.5729 16.666 10.2917 16.666 10.0001C16.666 9.70841 16.6488 9.4273 16.6143 9.15675C16.5793 8.88564 16.5271 8.61119 16.4577 8.33341H13.6243C13.666 8.61119 13.6971 8.88564 13.7177 9.15675C13.7388 9.4273 13.7493 9.70841 13.7493 10.0001C13.7493 10.2917 13.7388 10.5729 13.7177 10.8434C13.6971 11.1145 13.666 11.389 13.6243 11.6667ZM13.291 6.66675H15.7493C15.3466 5.9723 14.843 5.36814 14.2385 4.85425C13.6346 4.34036 12.9438 3.95841 12.166 3.70841C12.416 4.16675 12.6349 4.6423 12.8227 5.13508C13.0099 5.62841 13.166 6.13897 13.291 6.66675ZM8.41602 6.66675H11.5827C11.416 6.05564 11.2007 5.47925 10.9368 4.93758C10.673 4.39591 10.3605 3.87508 9.99935 3.37508C9.63824 3.87508 9.32574 4.39591 9.06185 4.93758C8.79796 5.47925 8.58268 6.05564 8.41602 6.66675ZM4.24935 6.66675H6.70768C6.83268 6.13897 6.98907 5.62841 7.17685 5.13508C7.36407 4.6423 7.58268 4.16675 7.83268 3.70841C7.0549 3.95841 6.36379 4.34036 5.75935 4.85425C5.15546 5.36814 4.65213 5.9723 4.24935 6.66675Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Language
                        </span>
                        <span>English, Igbo</span>
                      </li>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1917"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1917)">
                              <path
                                d="M3.33268 16.6666C2.87435 16.6666 2.48213 16.5035 2.15602 16.1774C1.82935 15.8508 1.66602 15.4583 1.66602 14.9999V4.99992C1.66602 4.54159 1.82935 4.14936 2.15602 3.82325C2.48213 3.49659 2.87435 3.33325 3.33268 3.33325H16.666C17.1243 3.33325 17.5168 3.49659 17.8435 3.82325C18.1696 4.14936 18.3327 4.54159 18.3327 4.99992V14.9999C18.3327 15.4583 18.1696 15.8508 17.8435 16.1774C17.5168 16.5035 17.1243 16.6666 16.666 16.6666H3.33268ZM9.99935 10.8333L3.33268 6.66659V14.9999H16.666V6.66659L9.99935 10.8333ZM9.99935 9.16658L16.666 4.99992H3.33268L9.99935 9.16658ZM3.33268 6.66659V4.99992V14.9999V6.66659Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Email
                        </span>
                        <span>kaict@gmail.com</span>
                      </li>
                      <li>
                        <span>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_545_1923"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_545_1923)">
                              <path
                                d="M3.375 17.5C3.125 17.5 2.91667 17.4167 2.75 17.25C2.58333 17.0833 2.5 16.875 2.5 16.625V13.25C2.5 13.0556 2.5625 12.8853 2.6875 12.7392C2.8125 12.5936 2.97222 12.5 3.16667 12.4583L6.04167 11.875C6.23611 11.8472 6.43417 11.8644 6.63583 11.9267C6.83694 11.9894 7 12.0833 7.125 12.2083L9.08333 14.1667C10.1389 13.5278 11.1078 12.7708 11.99 11.8958C12.8717 11.0208 13.6042 10.0833 14.1875 9.08333L12.1667 7.04167C12.0417 6.91667 11.9617 6.77417 11.9267 6.61417C11.8922 6.45472 11.8889 6.27778 11.9167 6.08333L12.4583 3.16667C12.4861 2.97222 12.5764 2.8125 12.7292 2.6875C12.8819 2.5625 13.0556 2.5 13.25 2.5H16.625C16.875 2.5 17.0833 2.58333 17.25 2.75C17.4167 2.91667 17.5 3.125 17.5 3.375C17.5 5.16667 17.1006 6.91306 16.3017 8.61417C15.5033 10.3158 14.4478 11.8228 13.135 13.135C11.8228 14.4478 10.3161 15.5033 8.615 16.3017C6.91333 17.1006 5.16667 17.5 3.375 17.5ZM14.9792 7.5C15.2153 6.95833 15.3958 6.40972 15.5208 5.85417C15.6458 5.29861 15.7431 4.73611 15.8125 4.16667H13.9583L13.6042 6.125L14.9792 7.5ZM7.52083 14.9583L6.125 13.5625L4.16667 13.9583V15.7917C4.73611 15.75 5.30222 15.6597 5.865 15.5208C6.42722 15.3819 6.97917 15.1944 7.52083 14.9583Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                          Phone Number
                        </span>
                        <span>+231 77 627 7932</span>
                      </li>
                    </ul>
                    <button className="btn-attend">{new Date(event.start_date)>new Date()?'Attend Event':'Past Event'}</button>
                    <button className="btn-download">Download Brochure</button>
                   
                  </div>
                </div>
                <div className="side-socials">
                  <img src="images/news/side-social.png" alt="" />
                  <div className="side-info">
                    <div className="side-contact">
                      <div className="icon one">
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_477_107"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="25"
                            height="25"
                          >
                            <rect width="25" height="25" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_477_107)">
                            <path
                              d="M20.7812 21.875C18.5417 21.875 16.3585 21.3759 14.2318 20.3776C12.105 19.3793 10.2214 18.0599 8.58073 16.4193C6.9401 14.7786 5.62066 12.895 4.6224 10.7682C3.62413 8.64149 3.125 6.45833 3.125 4.21875C3.125 3.90625 3.22917 3.64583 3.4375 3.4375C3.64583 3.22917 3.90625 3.125 4.21875 3.125H8.4375C8.68056 3.125 8.89757 3.20312 9.08854 3.35938C9.27951 3.51562 9.39236 3.71528 9.42708 3.95833L10.1042 7.60417C10.1389 7.84722 10.1345 8.06858 10.0911 8.26823C10.0477 8.46788 9.94792 8.64583 9.79167 8.80208L7.29167 11.3542C8.02083 12.6042 8.93229 13.776 10.026 14.8698C11.1198 15.9635 12.3264 16.9097 13.6458 17.7083L16.0937 15.2604C16.25 15.1042 16.454 14.987 16.7057 14.9089C16.9575 14.8307 17.2049 14.809 17.4479 14.8438L21.0417 15.5729C21.2847 15.625 21.4844 15.7422 21.6406 15.9245C21.7969 16.1068 21.875 16.3194 21.875 16.5625V20.7812C21.875 21.0938 21.7708 21.3542 21.5625 21.5625C21.3542 21.7708 21.0938 21.875 20.7812 21.875Z"
                              fill="#FCFCFC"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="text">
                        <h5>Call Us</h5>
                        <p>+231 77 627 7932</p>
                      </div>
                    </div>
                    <div className="side-contact">
                      <div className="icon two">
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_477_114"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="25"
                            height="25"
                          >
                            <rect width="25" height="25" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_477_114)">
                            <path
                              d="M4.16732 20.8334C3.5944 20.8334 3.10395 20.6294 2.69596 20.2214C2.28798 19.8134 2.08398 19.323 2.08398 18.7501V6.25008C2.08398 5.67716 2.28798 5.18671 2.69596 4.77873C3.10395 4.37074 3.5944 4.16675 4.16732 4.16675H20.834C21.4069 4.16675 21.8974 4.37074 22.3053 4.77873C22.7133 5.18671 22.9173 5.67716 22.9173 6.25008V18.7501C22.9173 19.323 22.7133 19.8134 22.3053 20.2214C21.8974 20.6294 21.4069 20.8334 20.834 20.8334H4.16732ZM12.5007 13.5417L20.834 8.33341V6.25008L12.5007 11.4584L4.16732 6.25008V8.33341L12.5007 13.5417Z"
                              fill="#FCFCFC"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="text">
                        <h5>Email Us</h5>
                        <p>kofiannaninstitute@ul.edu.lr</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="side-socials">
                  <div className="side-info">
                    <div className="social-side-icons">
                      <a href="#">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_477_641)">
                            <path
                              d="M30 15C30 6.71572 23.2843 0 15 0C6.71572 0 0 6.71572 0 15C0 22.4868 5.48525 28.6925 12.6562 29.8178V19.3359H8.84766V15H12.6562V11.6953C12.6562 7.93594 14.8957 5.85937 18.322 5.85937C19.9626 5.85937 21.6797 6.15234 21.6797 6.15234V9.84375H19.7883C17.925 9.84375 17.3438 11.0001 17.3438 12.1875V15H21.5039L20.8389 19.3359H17.3438V29.8178C24.5147 28.6925 30 22.4868 30 15Z"
                              fill="#25518C"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_477_641">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                      <a href="#">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_477_639)">
                            <path
                              d="M9.4377 27.1875C20.7557 27.1875 26.9479 17.8084 26.9479 9.67739C26.9479 9.41372 26.942 9.14418 26.9303 8.88051C28.1348 8.00939 29.1744 6.93038 30 5.69418C28.8782 6.19331 27.6871 6.51929 26.4674 6.66098C27.7516 5.8912 28.7132 4.6819 29.1738 3.25727C27.9657 3.97326 26.6445 4.47833 25.2668 4.75082C24.3385 3.76451 23.1112 3.11146 21.7746 2.89262C20.438 2.67379 19.0665 2.90137 17.8722 3.54018C16.6779 4.17899 15.7273 5.19344 15.1673 6.4267C14.6074 7.65996 14.4693 9.04333 14.7744 10.3629C12.3281 10.2402 9.93492 9.60469 7.74998 8.49768C5.56503 7.39068 3.63712 5.83686 2.09121 3.93696C1.3055 5.29162 1.06507 6.89462 1.41879 8.42018C1.77251 9.94573 2.69383 11.2794 3.99551 12.15C3.01829 12.119 2.06247 11.8559 1.20703 11.3825V11.4586C1.20616 12.8802 1.69762 14.2583 2.59789 15.3585C3.49815 16.4588 4.75165 17.2133 6.14531 17.4938C5.24007 17.7415 4.28998 17.7776 3.36855 17.5993C3.76182 18.8219 4.52697 19.8912 5.55721 20.658C6.58746 21.4248 7.8314 21.8508 9.11543 21.8766C6.93553 23.5889 4.24272 24.5177 1.4707 24.5133C0.979109 24.5126 0.487999 24.4824 0 24.4231C2.81607 26.2297 6.09191 27.1893 9.4377 27.1875Z"
                              fill="#25518C"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_477_639">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                      <a href="#">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_477_634)">
                            <path
                              d="M15 2.70117C19.0078 2.70117 19.4824 2.71875 21.0586 2.78906C22.5234 2.85352 23.3145 3.09961 23.8418 3.30469C24.5391 3.57422 25.043 3.90234 25.5645 4.42383C26.0918 4.95117 26.4141 5.44922 26.6836 6.14648C26.8887 6.67383 27.1348 7.4707 27.1992 8.92969C27.2695 10.5117 27.2871 10.9863 27.2871 14.9883C27.2871 18.9961 27.2695 19.4707 27.1992 21.0469C27.1348 22.5117 26.8887 23.3027 26.6836 23.8301C26.4141 24.5273 26.0859 25.0312 25.5645 25.5527C25.0371 26.0801 24.5391 26.4023 23.8418 26.6719C23.3145 26.877 22.5176 27.123 21.0586 27.1875C19.4766 27.2578 19.002 27.2754 15 27.2754C10.9922 27.2754 10.5176 27.2578 8.94141 27.1875C7.47656 27.123 6.68555 26.877 6.1582 26.6719C5.46094 26.4023 4.95703 26.0742 4.43555 25.5527C3.9082 25.0254 3.58594 24.5273 3.31641 23.8301C3.11133 23.3027 2.86523 22.5059 2.80078 21.0469C2.73047 19.4648 2.71289 18.9902 2.71289 14.9883C2.71289 10.9805 2.73047 10.5059 2.80078 8.92969C2.86523 7.46484 3.11133 6.67383 3.31641 6.14648C3.58594 5.44922 3.91406 4.94531 4.43555 4.42383C4.96289 3.89648 5.46094 3.57422 6.1582 3.30469C6.68555 3.09961 7.48242 2.85352 8.94141 2.78906C10.5176 2.71875 10.9922 2.70117 15 2.70117ZM15 0C10.9277 0 10.418 0.0175781 8.81836 0.0878906C7.22461 0.158203 6.12891 0.416016 5.17969 0.785156C4.18945 1.17187 3.35156 1.68164 2.51953 2.51953C1.68164 3.35156 1.17187 4.18945 0.785156 5.17383C0.416016 6.12891 0.158203 7.21875 0.0878906 8.8125C0.0175781 10.418 0 10.9277 0 15C0 19.0723 0.0175781 19.582 0.0878906 21.1816C0.158203 22.7754 0.416016 23.8711 0.785156 24.8203C1.17187 25.8105 1.68164 26.6484 2.51953 27.4805C3.35156 28.3125 4.18945 28.8281 5.17383 29.209C6.12891 29.5781 7.21875 29.8359 8.8125 29.9062C10.4121 29.9766 10.9219 29.9941 14.9941 29.9941C19.0664 29.9941 19.5762 29.9766 21.1758 29.9062C22.7695 29.8359 23.8652 29.5781 24.8145 29.209C25.7988 28.8281 26.6367 28.3125 27.4687 27.4805C28.3008 26.6484 28.8164 25.8105 29.1973 24.8262C29.5664 23.8711 29.8242 22.7812 29.8945 21.1875C29.9648 19.5879 29.9824 19.0781 29.9824 15.0059C29.9824 10.9336 29.9648 10.4238 29.8945 8.82422C29.8242 7.23047 29.5664 6.13477 29.1973 5.18555C28.8281 4.18945 28.3184 3.35156 27.4805 2.51953C26.6484 1.6875 25.8105 1.17187 24.8262 0.791016C23.8711 0.421875 22.7812 0.164062 21.1875 0.09375C19.582 0.0175781 19.0723 0 15 0Z"
                              fill="#25518C"
                            />
                            <path
                              d="M15 7.29492C10.7461 7.29492 7.29492 10.7461 7.29492 15C7.29492 19.2539 10.7461 22.7051 15 22.7051C19.2539 22.7051 22.7051 19.2539 22.7051 15C22.7051 10.7461 19.2539 7.29492 15 7.29492ZM15 19.998C12.2402 19.998 10.002 17.7598 10.002 15C10.002 12.2402 12.2402 10.002 15 10.002C17.7598 10.002 19.998 12.2402 19.998 15C19.998 17.7598 17.7598 19.998 15 19.998Z"
                              fill="#25518C"
                            />
                            <path
                              d="M24.8086 6.99011C24.8086 7.98621 24 8.78894 23.0098 8.78894C22.0137 8.78894 21.2109 7.98035 21.2109 6.99011C21.2109 5.99402 22.0195 5.19128 23.0098 5.19128C24 5.19128 24.8086 5.99988 24.8086 6.99011Z"
                              fill="#25518C"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_477_634">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                      <a href="#">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_477_632)">
                            <path
                              d="M27.7793 0H2.21484C0.990234 0 0 0.966797 0 2.16211V27.832C0 29.0273 0.990234 30 2.21484 30H27.7793C29.0039 30 30 29.0273 30 27.8379V2.16211C30 0.966797 29.0039 0 27.7793 0ZM8.90039 25.5645H4.44727V11.2441H8.90039V25.5645ZM6.67383 9.29297C5.24414 9.29297 4.08984 8.13867 4.08984 6.71484C4.08984 5.29102 5.24414 4.13672 6.67383 4.13672C8.09766 4.13672 9.25195 5.29102 9.25195 6.71484C9.25195 8.13281 8.09766 9.29297 6.67383 9.29297ZM25.5645 25.5645H21.1172V18.6035C21.1172 16.9453 21.0879 14.8066 18.8027 14.8066C16.4883 14.8066 16.1367 16.6172 16.1367 18.4863V25.5645H11.6953V11.2441H15.9609V13.2012H16.0195C16.6113 12.0762 18.0645 10.8867 20.2266 10.8867C24.7324 10.8867 25.5645 13.8516 25.5645 17.707V25.5645Z"
                              fill="#25518C"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_477_632">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="left">
                <div className="single-news">
                  <div className="news-thumbnail black">
                    <img src={event.image.url} alt="" />
                  </div>
                  <div className="black-content">
                    <div className="black-head">
                      <h2>Overview</h2>
                    </div>
                    <div className="black-text">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: event.description,
                        }}
                      ></p>
                    </div>
                  
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>

        {loading ? (
          <p>Loaing...</p>
        ) : (
          <RelatedEvents events={upcomingevents} loading={loading} />
        )}
      </main>
      <Footer />
    </>
  );
};

export default SingleEvent;
